<script>
    export default {
        props: ['route', 'target', 'jobStatus', 'alertText', 'jobLastDateStart'],
        data() {
            return {
                running: false
            }
        },
        mounted() {
            if(this.jobStatus == 'running') {
                this.running = true;
            }
            Event.$on('syncAll', () => {
                if(this.target == 'all' || this.running == true) {
                    return;
                }

                this.run();
            });
            Event.$on('syncSingle', () => {
                if(this.target == 'all') {
                    this.running = true;
                }
            });
        },
        methods: {
            run() {
                this.running = true;
                if(this.target == 'all') {
                    Event.$emit('syncAll');
                    return;
                }else{
                    this.jobStatus == 'running';
                    $(".main-sync-status").addClass("fa-spin");
                    Event.$emit('syncSingle');
                }
                axios.post(this.route, [])
                    .then((res) => {
                        if(res.data.jobStatus === 'completed') {
                            this.running = false;
                        }
                    });
            },
            confirm() {
                let that = this;
                Swal.fire({
                    text: this.alertText,
                    icon: "warning",
                    buttonsStyling: false,
                    showCancelButton: true,
                    cancelButtonText: _t('No'),
                    confirmButtonText: _t('Yes'),
                    customClass: {
                        confirmButton: 'btn btn-success',
                        cancelButton: 'btn btn-danger',
                    }
                }).then(function (result) {
                        if(result.value) {
                            that.run()
                        }

                        return false
                    });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/app/components/topbar/syncItems.vue